function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.014.559a2 2 0 011.972 0l4.234 2.4 4.195 2.466a2 2 0 01.986 1.709L22.44 12l-.039 4.866a2 2 0 01-.986 1.709L17.22 21.04l-4.234 2.4a2 2 0 01-1.972 0l-4.234-2.4-4.195-2.466a2 2 0 01-.986-1.709L1.56 12l.039-4.866a2 2 0 01.986-1.709L6.78 2.96l4.234-2.4z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.972 9.858c.007.089.007.178.007.267 0 2.709-2.063 5.83-5.832 5.83A5.792 5.792 0 017 15.036c.165.02.324.026.495.026.958 0 1.84-.323 2.544-.876a2.053 2.053 0 01-1.916-1.42c.127.018.254.03.387.03.184 0 .368-.024.54-.069a2.05 2.05 0 01-1.644-2.011v-.026c.273.153.59.248.926.26a2.048 2.048 0 01-.634-2.74 5.825 5.825 0 004.226 2.144 2.315 2.315 0 01-.05-.47c0-1.129.913-2.049 2.049-2.049.59 0 1.123.247 1.497.647.463-.089.907-.26 1.3-.495a2.044 2.044 0 01-.9 1.13A4.11 4.11 0 0017 8.798c-.28.407-.628.768-1.028 1.06z",
  fill: "#1976D2"
});

function SvgSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgSocialTwitter;